import { getWalletsWatcher } from './get-wallets.saga';
import { getWalletTransactionsWatcher } from './get-transactions.saga';
import { withdrawWalletWatcher } from './withdraw-wallets.saga';

export default [
  getWalletsWatcher(),
  getWalletTransactionsWatcher(),
  withdrawWalletWatcher(),
];
